import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { Link } from "react-router-dom";
import products from '../../data/products.json';
import { useLanguage } from '../../context/LanguageContext';
import ScrollFadeIn from "../../routes/ScrollFadeIn";
import { motion, useInView } from "framer-motion";

export const Home = React.memo(() => {

const BulletproofCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const images = [
    "gpt_banner1.png",
    "gemini1.png",
    "gemini2.png"
  ];

  useEffect(() => {
    if (isHovered) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3400); 

    return () => clearInterval(timer);
  }, [isHovered, images.length]); 

  return (
    <div 
      style={{ display: "grid", width: "100%", height: "100%", overflow: "hidden" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {images.map((src, index) => (
        <img
          key={src}
          src={src}
          alt={`Slide ${index + 1}`}
          className="img111"
          style={{
            gridArea: "1 / 1", 
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: currentIndex === index ? 1 : 0,
            zIndex: currentIndex === index ? 2 : 1,
            transition: "opacity 1s ease-in-out" 
          }}
        />
      ))}
    </div>
  );
};
  const { language, setLanguage, t } = useLanguage();
  const productsRef = React.useRef<HTMLDivElement | null>(null);

  const scrollToProducts = () => {
    productsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((prev) => !prev);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      window.addEventListener('keydown', handleEscape);
    }

    return () => window.removeEventListener('keydown', handleEscape);
  }, [menuOpen]);

  const textRef = React.useRef<HTMLHeadingElement | null>(null);
  const subtextRef = React.useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    const onScroll = () => {
      const triggerPoint = window.innerHeight * 0.8;

      if (textRef.current && textRef.current.getBoundingClientRect().top < triggerPoint) {
        textRef.current.style.opacity = '1';
        textRef.current.style.transform = 'translateY(0)';
      }

      if (subtextRef.current && subtextRef.current.getBoundingClientRect().top < triggerPoint) {
        subtextRef.current.style.opacity = '1';
        subtextRef.current.style.transform = 'translateY(0)';
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const topText1Ref = useRef(null);
  const topText2Ref = useRef(null);
  const isTopText1InView = useInView(topText1Ref, { once: true, margin: "-100px" });
  const isTopText2InView = useInView(topText2Ref, { once: true, margin: "-100px" });


  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  return (
    <div className="homediv">

      <div className="global-outline-circle"></div>

      <div className="headertext">
        <h3>{t("super_durable")}</h3>
      </div>

      <div className="linksandlanguage">

        {/* LEFT */}
        <div className="navbar-left">
          <img
            className="linksdivlogo"
            src="smart_bag_logo_png.png"
            alt=""
          />

          <div className="nav-shape-1"></div>
          <div className="nav-shape-2"></div>
          <div className="nav-shape-3"></div>
        </div>

        {/* CENTER */}
        <nav className="navbar-center-links">

          <Link to="/FindProduct">
            <button className="fancy-underline-button">
              {t("find_your_bag")}
            </button>
          </Link>

          <button
            className="fancy-underline-button"
            onClick={scrollToProducts}
          >
            {t("products")}
          </button>

          <Link to="/about">
            <button className="fancy-underline-button">
              {t("About_Us")}
            </button>
          </Link>

        </nav>

        {/* RIGHT */}
        <div className="navbar-right">

          <div className="select-wrapper">
            <select
              className="languagediv"
              value={language}
              onChange={(e) => setLanguage(e.target.value as any)}
            >
              <option value="en">English</option>
              <option value="hy">Հայերեն</option>
              <option value="ru">Русский</option>
            </select>
          </div>

          <div className="linksdiv">

            <a
              href="https://www.facebook.com/profile.php?id=100026704725346&locale=ru_RU"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="facebook.png" alt="" className="logo1" style={{ filter: "invert(1)" }} />
            </a>

            <a
              href="https://www.instagram.com/smartbag_armenia/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="instagram.png" alt="" className="logo1" />
            </a>

          </div>

          <div
            className="hamburger"
            onClick={toggleMenu}
            aria-label={t("open_mobile_menu")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") toggleMenu();
            }}
          >
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>

        </div>

      </div>

<div className={`menu-overlay ${menuOpen ? "show" : ""}`} onClick={() => setMenuOpen(false)}>
        <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
          <button onClick={() => { scrollToProducts(); setMenuOpen(false); }} className="fancy-underline-button">
            {t("products")}
          </button>
          
          <Link to="/FindProduct">
            <button onClick={() => setMenuOpen(false)} className="fancy-underline-button">
              {t("find_your_bag")}
            </button>
          </Link>

          {/* Add the About Us link here */}
          <Link to="/about">
            <button onClick={() => setMenuOpen(false)} className="fancy-underline-button">
              {t("About_Us")}
            </button>
          </Link>
          
        </div>
      </div>

      <div className="advertismentphoto">
        <div className="div111">

          <div className="hero-overlay">
            <motion.div
              className="hero-content"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >

              <div className="hero-mini-line"></div>

              <p className="hero-small-text">
                {t("premium_filtration")}
              </p>

              <h1>
                {t("welcome_to_smart_bag")}
              </h1>

              <p className="hero-description">
                {t("hero_description")}
              </p>

              <div className="hero-features">
                <div className="hero-feature">
                  <img src="/layers.png" alt="" />
                  <span>{t("filtration_99_9")}</span>
                </div>

                <div className="hero-feature">
                  <img src="/layers.png" alt="" />
                  <span>{t("layers_4")}</span>
                </div>

                <div className="hero-feature">
                  <img src="/layers.png" alt="" />
                  <span>{t("durable_material")}</span>
                </div>
              </div>



            </motion.div>
          </div>

<BulletproofCarousel />
        </div>
      </div>

      <div className="main-video-div-wrapper">
        <div className="main-video-div">
          <div className="top-texts">
            <div className="floating-blur blur-one"></div>
            <div className="floating-blur blur-two"></div>
            <div className="text-box" ref={topText1Ref}>
              <div className="mini-label">
                {t("premium_quality")}
              </div>

              <motion.h1
                initial={{ y: 30, opacity: 0 }}
                animate={isTopText1InView ? { y: 0, opacity: 1 } : {}}
                transition={{ duration: 0.8 }}
              >
                {t("hero_title_1_prefix")}{" "}
                <span className="highlight">
                  {t("hero_title_1_highlight")}
                </span>{" "}
                {t("hero_title_1_suffix")}
              </motion.h1>

              <p>
                {t("hero_desc_1")}
              </p>
            </div>
            <div className="text-box" ref={topText2Ref}>
              <div className="mini-label">
                {t("smart_filtration")}
              </div>

              <motion.h1
                initial={{ y: 30, opacity: 0 }}
                animate={isTopText2InView ? { y: 0, opacity: 1 } : {}}
                transition={{ duration: 0.8 }}
              >
                {t("hero_title_2_prefix")}{" "}
                <span className="highlight">
                  {t("hero_title_2_highlight")}
                </span>{" "}
                {t("hero_title_2_suffix")}
              </motion.h1>

              <p>
                {t("hero_desc_2")}
              </p>
            </div>
          </div>

          <div className="bottom-section">
            <motion.div
              className="video-box"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            >
              <video autoPlay loop muted playsInline preload="auto" className="video">
                <source src="/video1.mp4" type="video/mp4" />
              </video>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="main_icons_div">
        <ScrollFadeIn>
          <div className="icons_div">
            <img src="vacuum_cleaner_icon.png" alt="" className="icons_photos" />
            <h3>{t("clean_air")}</h3>
            <p>{t("clean_air_desc")}</p>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn>
          <div className="icons_div">
            <img src="ruler.png" alt="" className="icons_photos" />
            <h3>{t("perfect_fit")}</h3>
            <p>{t("perfect_fit_desc")}</p>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn>
          <div className="icons_div">
            <img src="layers.png" alt="" className="icons_photos" />
            <h3>{t("built_to_last")}</h3>
            <p>{t("built_to_last_desc")}</p>
          </div>
        </ScrollFadeIn>
      </div>

      <div className="parallax_wrapper">
        <div className="parallax_section"></div>
        <div className="parallax_content">
          <h1 ref={textRef} className="parallax_text">{t("experience_true_clean")}</h1>
          <p ref={subtextRef} className="parallax_subtext">{t("breathe_in_purity")}</p>
        </div>
      </div>

      <div className="productsdiv" ref={productsRef}>
        <div className="products-circle products-circle-1"></div>
        <div className="products-circle products-circle-2"></div>

        <div className="products-outline products-outline-1"></div>
        <div className="products-outline products-outline-2"></div>

        <div className="products-dots-grid products-dots-grid-1"></div>
        <div className="products-dots-grid products-dots-grid-2"></div>

        <div className="products-soft-shape products-soft-shape-1"></div>
        <div className="products-soft-shape products-soft-shape-2"></div>

        <div className="products-center-outline"></div>
        <div className="products-center-blur"></div>
        <div className="products-center-dots"></div>
        <div className="categorydiv">
          <div className="productcategory">
            <p>{t("disposable")}</p>
          </div>
        </div>
        <div className="allproducts">
          {products.slice(0, 8).map((product) => (
            <Link to={`/selling/${product.id}`} key={product.id}>
              <motion.div
                className="theproduct"
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 }}
                whileHover={{ y: -6, scale: 1.02 }}
                whileTap={{ scale: 0.97 }}
              >
                <div className="prodimage">
                  <img src={product.image[0]} alt="" className="imageofproduct1" />
                </div>
                <div className="productprice">
                  <h5>{product.name}</h5>
                </div>
                <div className="producicon">
                  <img src="/info.png" alt="" className="shippingphoto" />
                  {t("more_info")}
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>

      <motion.button
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        initial={{ opacity: 0 }}
        animate={{ opacity: showButton ? 1 : 0, y: showButton ? 0 : 20 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        style={{ display: showButton ? 'block' : 'none' }}
      >
        ↑ {t("back_to_top")}
      </motion.button>

      <div className="homeinfodiv">
        <div className="homedivh1">
          <h1>{t("final_slogan")}</h1>
        </div>
        <footer>
          <motion.div
            className="main-container"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            whileHover={{ scale: 1.04, y: -4 }}
            whileTap={{ scale: 0.97 }}
          >
            <h2>{t("customer_service")}</h2>
            <div className="info-item">
              <h3>{t("contact")}</h3>
              <p>(043)908085</p>
            </div>
            <div className="info-item">
              <h3>{t("place")}</h3>
              <p>{t("armenia")}</p>
            </div>
            <div className="info-item">
            </div>
          </motion.div>

          <motion.div
            className="main-container"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            whileHover={{ scale: 1.04, y: -4 }}
            whileTap={{ scale: 0.97 }}
          >
            <h2>{t("popular_brands")}</h2>
            <div className="companies-container">
              <div className="brands-grid">
                <img src="lglogo.png" alt="LG" />
                <img src="panasoniclogo.png" alt="Panasonic" />
                <img src="samsunglogo.png" alt="Samsung" />
                <img src="vaxlogo.png" alt="Vax" />
                <img src="boschlogo.png" alt="Bosch" />
                <img src="zelmerlogo.png" alt="Zelmer" />
                <img src="electroluxlogo.png" alt="Electrolux" />
                <img src="philipslogo.png" alt="Philips" />
                <img src="borklogo.png" alt="Bork" />
              </div>
            </div>
          </motion.div>

          <motion.div
            className="main-containerr"
            transition={{ duration: 0.6, ease: "easeOut" }}
            whileHover={{ scale: 1.03 }}
          >
            <div className="flex-container">
              <h2>{t("keep_in_touch")}</h2>
              <div className="icon-row">
                <span className="icon">          <a href="https://www.instagram.com/smartbag_armenia/" target="_blank" rel="noopener noreferrer"><img src="instagram.png" alt="" style={{ width: "30px" }} /></a></span>
                <span className="icon">          <a href="https://www.facebook.com/profile.php?id=100026704725346&locale=ru_RU" target="_blank" rel="noopener noreferrer"><img src="facebook.png" alt="" style={{ filter: "invert(1)", width: "30px" }} /></a></span>
                <span className="icon"><img src="youtube.png" alt="" style={{ width: "30px" }} /></span>
              </div>
            </div>
          </motion.div>
        </footer>
      </div>

      <div className="lastdiv">
        {t("all_rights_reserved")} || {t("thanks_for_coming")}
      </div>
    </div>
  );
});
